import { useEffect, useState } from 'react';

import { NAVIGATION_OFFSET_CSS_VARIABLE } from './constants';

export const useNavigationOffset = ({ enabled = true }: { enabled?: boolean } = {}) => {
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        const getOffsetValue = () => {
            const value = getComputedStyle(document.documentElement)
                .getPropertyValue(NAVIGATION_OFFSET_CSS_VARIABLE)
                ?.trim();

            return parseInt(value, 10) || 0;
        };

        setOffset(getOffsetValue());

        const styleObserver = new MutationObserver(() => {
            const newOffset = getOffsetValue();
            setOffset(newOffset);
        });

        styleObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['style'],
        });

        return () => styleObserver.disconnect();
    }, [enabled]);

    return {
        offset,
    };
};
